import React, { FC } from 'react';
import { useRecoilValue } from 'recoil';

import { onDemandPageTestIDs } from '@constants';
import { useGetContinueWatching } from '@hooks';
import { vodLadingState } from '@store';

import { OnDemandContent } from './OnDemandContent/OnDemandContent';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

export const OnDemandPage: FC = () => {
  const { data } = useRecoilValue(vodLadingState);
  const { data: continueWatchingData } = useGetContinueWatching();

  return (
    <TWCPage
      childIds={[onDemandPageTestIDs.mainLayout, onDemandPageTestIDs.promoArea]}
      firstFocus={onDemandPageTestIDs.promoArea}
      isMenuItem
      pageID={onDemandPageTestIDs.onDemandPage}
    >
      <OnDemandContent continueWatching={continueWatchingData} data={data?.homepage} />
    </TWCPage>
  );
};
